<template>
  <div>
    <div
      v-if="path == 'organization'"
      class="organization"
      v-loading="isLoading"
    >
      <header-top></header-top>
      <div class="header-title">部门管理</div>
      <div class="organization-container">
        <div class="post-container">
          <div class="container-tip">
            <svg-icon icon-class="icon-tips" class="icon-tips" />
            <ul>
              <svg-icon
                icon-class="tips-bg"
                class="icon-tips-bg"
                v-if="showTips"
              />
              <li class="tips-tit">
                小贴士
                <i
                  class="el-icon-caret-top tips-btn"
                  v-if="showTips"
                  @click="showTip"
                ></i>
                <i
                  class="el-icon-caret-bottom tips-btn"
                  v-else
                  @click="showTip"
                ></i>
              </li>
              <li v-if="showTips">
                <span></span>
                <div>
                  添加组织架构后，可关联权限组，用户划分到组织架构后，将启用权限组上的权限
                </div>
              </li>
              <li v-if="showTips">
                <span></span>
                <div>一个组织架构可关联多个权限组，关联后以最大权限为主</div>
              </li>
              <li v-if="showTips">
                <span></span>
                <div>
                  创建组织架构时请以公司实际人事架构为准，请尽量应用标签，便于区分组织架构的属性
                </div>
              </li>
            </ul>
          </div>
          <div class="container-main">
            <div class="main-left">
              <div class="left-operation">
                <div class="operation-btn">
                  <el-tooltip
                    placement="top"
                    popper-class="custom-tooltip"
                    effect="light"
                  >
                    <div slot="content">添加</div>
                    <div @click.stop="addOrg">
                      <svg-icon icon-class="add-ico" class="btn-add" />
                    </div>
                  </el-tooltip>
                  <el-tooltip
                    placement="top"
                    popper-class="custom-tooltip"
                    effect="light"
                  >
                    <div slot="content">刷新</div>
                    <div @click.stop="refreshOrgs">
                      <svg-icon icon-class="refresh-ico" class="btn-refresh" />
                    </div>
                  </el-tooltip>
                  <el-tooltip
                    placement="top"
                    popper-class="custom-tooltip"
                    effect="light"
                  >
                    <div slot="content">删除</div>
                    <div @click.stop="delOrg">
                      <svg-icon icon-class="del-ico" class="btn-del" />
                    </div>
                  </el-tooltip>
                </div>
                <el-input
                  v-if="orgAll.length"
                  class="operation-search"
                  placeholder="请输入组织架构名称"
                  v-model="orgSearch"
                  suffix-icon="el-icon-search"
                  clearable
                ></el-input>
              </div>
              <el-tree
                class="custom-tree"
                v-show="orgAll.length"
                v-loading="refresh"
                lazy
                :data="orgs"
                :props="{ children: 'children', isLeaf: 'isLeaf' }"
                node-key="id"
                :load="loadTreeNodes"
                empty-text=""
                @node-click="nodeClick"
              >
                <span class="custom-tree-node" slot-scope="{ data }">
                  <span>{{ data.data.name }}</span>
                  <el-tooltip
                    placement="top"
                    popper-class="custom-tooltip"
                    effect="light"
                  >
                    <div slot="content">添加下级</div>
                    <span @click.stop="addOrg(data)">
                      <svg-icon icon-class="add-ico" class="btn-append" />
                    </span>
                  </el-tooltip>
                </span>
              </el-tree>
            </div>

            <div
              class="main-right"
              v-show="orgs.length || operation.name == 'create'"
            >
              <el-tabs v-model="activeName" @tab-click="tabClick">
                <el-tab-pane label="基本信息" name="basic-info">
                  <basic-info
                    ref="basicInfo"
                    :operation="operation"
                    :selectedId="selectedId"
                    :organization="organization"
                    :permissionRoles="permissionForm"
                    @updateOrg="updateOrg"
                    @createOrg="searchOrgs"
                  ></basic-info>
                </el-tab-pane>
                <!-- <el-tab-pane label="支付设置" name="payment">
                <payment
                  v-if="activeName=='payment'"
                  :organization="organization"
                  :selectedId="selectedId"
                ></payment>
              </el-tab-pane> -->
                <el-tab-pane
                  label="操作日志"
                  name="third"
                  v-if="
                    permissions[
                      'AuditLogging.ViewChangeHistory:Aiwins.Rocket.Identity.OrganizationUnit'
                    ]
                  "
                >
                  <operation-record
                    :selectedId="selectedId"
                    v-if="activeName == 'third'"
                  ></operation-record>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div
              class="main-right-none"
              v-if="orgs.length == 0 && operation != 'create'"
            >
              <img src="@/assets/image/none-img.png" alt="" />
              <div class="none-tips">
                当前暂无组织，单击下面“立即添加”按钮添加新组织。
              </div>
              <el-button type="primary" @click="addOrg">立即添加</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import basicInfo from "./basic-info";
import operationRecord from "./operation-record";
import headerTop from "@/components/HeaderTop";
import { search } from "@/utils/tree";
import {
  getOrgAllTree,
  getOrgTree,
  deleteOrg,
  getOrgInfo,
  moveOrg,
} from "@/http/api/organization";
import { debounce } from "@/utils/debounce";

export default {
  computed: {
    path() {
      return this.$route.name;
    },
  },
  components: {
    basicInfo,
    operationRecord,
    headerTop,
  },
  data() {
    return {
      activeName: "basic-info",
      orgSearch: "",
      operation: { name: "checked", id: null },
      selectedId: "",
      isLoading: true,
      refresh: false,
      orgs: [],
      organization: {},
      orgAll: [],
      permissionForm: [],
      showTips: true,
      isDraggable: true,
      permissions: this.$store.getters.permissions,
    };
  },
  mounted() {
    this.searchOrgs();
    this.isDraggable = this.permissions["RocketIdentity.Users.Update"];
    // 防抖搜索
    this.$watch(
      "orgSearch",
      debounce((val) => {
        this.searchOrgs();
      }, 200)
    );
  },
  methods: {
    updateOrg(val) {
      //console.log(val, val.name);
      // this.orgs = search(this.orgs, this.organization.name,val.name)
      // //console.log(this.orgs);
      if(val.parentId!=this.organization.parentId){
        this.searchOrgs();
      }
      this.organization = val;
    },
    showTip() {
      this.showTips = !this.showTips;
    },
    // // 设置拖拽
    // allowDrop(draggingNode, dropNode, type) {
    //   let draggingId = draggingNode.parent.id,
    //     dropId = dropNode.parent.id;
    //   if (draggingId == dropId && type != "inner") {
    //     // 禁止同级非inner操作
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
    // 懒加载树形数据
    loadTreeNodes(val, resolve) {
      var node = val.data.data;
      if (node) {
        let query = {
          parentId: node.id,
          loadMode: "async",
          maxResultCount: 1000,
        };
        getOrgTree(query).then((res) => {
          resolve(res.result.items);
        });
      }
    },
    //刷新refresh
    refreshOrgs() {
      this.refresh = true;
      this.searchOrgs();
    },
    // 搜索组织
    searchOrgs() {
      if (this.orgSearch) {
        let query = {
          loadMode: "async",
          filter: this.orgSearch,
          maxResultCount: 1000,
        };
        getOrgTree(query).then((res) => {
          this.orgs = res.result.items;
          this.refresh = false;
          if (this.orgs.length) {
            this.getOrgInfo(this.orgs[0].data.id);
          }
        });
      } else {
        getOrgTree({ loadMode: "async", maxResultCount: 1000 }).then((res) => {
          this.orgAll = res.result.items;
          this.orgs = this.orgAll;
          if (this.orgs.length) {
            this.getOrgInfo(this.orgs[0].data.id);
          }
          this.refresh = false;
          this.isLoading = false;
        });
      }
    },
    // 获取组织详情
    getOrgInfo(id) {
      getOrgInfo(id).then((res) => {
        console.log(res.result,"获取的组织");
        this.organization = res.result;
        this.selectedId = this.organization.id;
        this.getOrgRoles();
      });
    },
    // 获取组织权限
    getOrgRoles() {
      let arr = [],
        ids = [];
      this.organization.roles.map((item) => {
        arr.push(item.id + " " + item.name);
        ids.push(item.id);
      });
      this.permissionForm = arr;
    },
    // 删除节点
    delOrg() {
      if (this.organization.isDefault) {
        this.$message.warning({
          message: `默认职务职级不可删除`,
          showClose: true,
        });
      } else {
        if (this.permissions["RocketIdentity.OrganizationUnits.Delete"]) {
            this.$confirm("此操作将永久删除该组织, 是否继续?", "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            })
              .then(() => {
                deleteOrg(this.selectedId).then((res) => {
                  if (res) {
                    if (res) {
                      this.$message.success({
                        message: "删除成功",
                        showClose: true,
                      });
                    }
                  }
                  this.searchOrgs();
                  this.operation = { name: "", id: null };;
                });
              })
              .catch(() => {
                //console.log("已取消");
              });
        } else {
          this.$message.warning({
            message: `您暂无部门删除权限`,
            showClose: true,
          });
        }
      }
    },
    // 添加组织
    addOrg(data) {
      if (this.permissions["RocketIdentity.OrganizationUnits.Create"]) {
        if (data.data) {
          this.operation = { name: "createSubordinate", id: data.data.id };
        } else {
          this.operation = { name: "createTop", id: null };
        }

        this.$refs.basicInfo.createOrg();
      } else {
        this.$message.warning({
          message: `您暂无部门创建权限`,
          showClose: true,
        });
      }
    },
    // 点击节点
    nodeClick(node, data) {
      // 避免重复获取
      this.activeName = "basic-info";
      this.operation = { name: "checked", id: null };
      if (this.selectedId != node.data.id) {
        this.selectedId = node.data.id;
        this.getOrgInfo(this.selectedId);
        this.$refs.basicInfo.cancel();
      }
    },
    // 拖拽结束回调
    dragEnd(node, data, status) {
      let query = {};
      if (status == "inner") {
        query = {
          id: node.data.data.id,
          parentId: data.data.data.id,
        };
      } else if (status == "before" || status == "after") {
        let parent = data.parent.data;
        if (Array.isArray(parent)) {
          query = {
            id: node.data.data.id,
          };
        } else {
          query = {
            id: node.data.data.id,
            parentId: parent.data.id,
          };
        }
      } else if (status == "none") {
        return;
      }
      moveOrg(query).then((res) => {
        this.searchOrgs();
      });
    },
    // 点击标签页
    tabClick() {},
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.organization {
  // height: calc(100vh - 50px);
  // overflow-y: auto;
  .title {
    color: #000000;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 17px 20px 17px;
    background: rgba(255, 255, 255, 1);
  }

  .svg-icon {
    cursor: pointer;
  }

  .organization-container {
    padding: 20px;
    .container-tip {
      @include flex(row, flex-start);
      margin-bottom: 20px;
      padding: 20px;
      font-size: 12px;
      font-weight: 500;
      background: #fff;
      .icon-tips {
        color: $--color-primary;
        padding: 10px 0;
      }
      ul {
        margin: 0;
        position: relative;
        padding-left: 10px;
        width: 100%;
        .icon-tips-bg {
          position: absolute;
          right: 0px;
          bottom: -94px;
          font-size: 250px;
        }
        li {
          @include flex(row, center);
          margin-bottom: 10px;
          width: 100%;
          span {
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
            padding: 2px;
            background: #111;
          }
        }
        .tips-tit {
          justify-content: space-between;
          .tips-btn {
            position: relative;
            z-index: 99;
            padding: 10px;
            cursor: pointer;
          }
        }
        li:last-child {
          margin-bottom: 0px;
        }
      }
    }

    .container-main {
      display: flex;
      //

      .main-left {
        border-radius: $--border-radius-base;
        margin-right: 20px;
        padding: 20px;
        width: 360px;
        background: #fff;
        .left-operation {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .operation-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;

            width: 50px;

            .el-tooltip {
              height: 16px;
              &:first-child {
                // height: 10px;
              }
            }

            .btn-add {
              width: 10px;
              height: 10px;
              vertical-align: baseline;
            }
            .btn-refresh {
              margin: 0 10px;
              width: 15px;
              height: 18px;
            }
            .btn-del {
              width: 16px;
              height: 16px;
              color: #888;
              :focus {
                outline: none;
              }
            }
          }

          .operation-search {
            width: 260px;
            height: 30px;

            .el-icon-search {
              cursor: pointer;
            }
          }
        }

        .el-tree {
          margin-top: 20px;

          .el-tree-node {
            margin-bottom: 10px;
          }
        }
      }

      .main-right {
        border-radius: $--border-radius-base;
        overflow: hidden;
        padding: 20px;
        width: calc(100% - 400px);
        background: #fff;
        ::v-deep .el-tabs {
          width: calc(100% + 10px);
          position: relative;
          right: 10px;
          .el-tabs__header {
            box-shadow: 0 2px 3px rgba(0, 0, 0, 0);
          }
          // .el-tab-pane {
          //   min-height: calc(100vh - 304px);
          // }
        }
      }
      .main-right-none {
        @include flex(column, center);
        justify-content: center;
        padding: 20px;
        width: calc(100% - 354px);
        background: #fff;
        img {
          margin-bottom: 10px;
          width: 20%;
          height: auto;
        }
        .none-tips {
          margin-bottom: 10px;
          color: #888888;
        }
      }
    }

    // .min-height {
    //   min-height: calc(100vh - 258px);
    // }
  }
}
</style>